import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn';

export type IconButtonProps = {
  label: string;
  children: ReactNode;
  className?: string;
  tone?: 'default' | 'danger';
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'aria-label'>;

export function IconButton({
  label,
  children,
  className,
  tone = 'default',
  type = 'button',
  ...props
}: IconButtonProps) {
  return (
    <button
      type={type}
      aria-label={label}
      title={label}
      className={cn(
        'inline-flex size-7 items-center justify-center rounded-ds-md border border-transparent',
        'text-ds-muted transition-colors duration-ds-fast ease-ds',
        'hover:bg-ds-subtle hover:text-ds-text',
        'disabled:pointer-events-none disabled:opacity-50',
        '[&_svg]:size-4',
        tone === 'danger' && 'hover:bg-ds-danger-subtle hover:text-ds-danger',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
